import { CompanyAPI } from '@api';

const getGroupPrices = async (groupsIds) => {
  const params = {
    groupsIds,
  };

  return CompanyAPI.getGroupPrices(params)
    .then(({ data }) => data)
    .catch((error) => Promise.reject(error.response));
};

export { getGroupPrices };
